// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';
import { Button } from '@mui/material';
import { BiImport } from 'react-icons/bi';

import ImportDriversModal from '@features/drivers/components/ImportDriversModal';
import DriverManagement from '@features/userManagement/components/DriverManagement';
import { useRooftop } from '@store';

// COMPONENT ---------------------------------------------------------------- //

const DriversPage = () => {
  const rooftop = useRooftop();
  const customerIds = React.useMemo(
    () => (rooftop?.id ? [rooftop.id] : []),
    [rooftop?.id],
  );

  const [importModalOpen, setImportModalOpen] = React.useState(false);

  return (
    <>
      <ImportDriversModal open={importModalOpen} onClose={() => setImportModalOpen(false)} />

      <DriverManagement
        customerIds={customerIds}
        actions={
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<BiImport />}
            onClick={() => setImportModalOpen(true)}
            sx={{ textTransform: 'none' }}
          >
            Import Drivers
          </Button>
        }
      />
    </>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default DriversPage;
